import React from 'react'
import { DoctorPatientProfile } from '../../types/doctorPatients.types'
import { PatientContacts } from './PatientContacts'
import { Stack } from '@mui/material'

interface PatientContactsProps {
  patientProfile: DoctorPatientProfile
  refetchPatientProfile: () => void
}

export const PatientContactsSection: React.FC<
  React.PropsWithChildren<PatientContactsProps>
> = ({ patientProfile, refetchPatientProfile }) => {
  return (
    <Stack>
      <PatientContacts
        contacts={patientProfile.emergencyContacts}
        contactType="emergency"
        patientProfile={patientProfile}
        refetchPatientProfile={refetchPatientProfile}
      />

      <div
        style={{
          height:
            (patientProfile.entitleToInfoContacts?.length ?? 0) > 0
              ? '24px'
              : 0,
        }}
      />
      <PatientContacts
        contacts={patientProfile.entitleToInfoContacts}
        contactType="entitleToInfo"
        patientProfile={patientProfile}
        refetchPatientProfile={refetchPatientProfile}
      />
    </Stack>
  )
}
